import HwpTvApi from '../../hwpTvApi';
import { getLogger } from '../../logging/logger';
import BaseGame from '../baseGame';

const logger = getLogger('GameTeamChooser');

export default class GameTeamChooser extends BaseGame {
	defaults() {
		return {
			...super.defaults(),
			type: 'teamChooser',
			skipIfComplete: false,
			chosenTeam: undefined,
		};
	}

	get chosenTeam() {
		logger.debug('[chosenTeam]', { chosenTeam: this.get('chosenTeam') });

		return this.get('chosenTeam');
	}

	submitChosenTeam(team) {
		logger.log('[submitChosenTeam]', { team });

		if (team) {
			this.set('chosenTeam', team);

			const gameId = this.get('gameId');
			if (gameId) {
				HwpTvApi.submitGameUserAnswer(gameId, 'chosenTeam', {
					userAnswer: team,
					engine: this.type,
				});
			}

			// Track which team user chooses
			this.sendGA4Event('TeamChoosen', { team });
		}
	}

	/**
	 * @override
	 * Team chooser does not use the typical rounds and questions paradaigm. Instead, it stores
	 * the user's team choice as the first answer for the game.
	 * @param {array} answersArray Array of answers retrieved from the HWP TV API
	 */
	syncAnswers(answersArray) {
		logger.log('[syncAnswers]', { answersArray });

		if (answersArray && answersArray.length) {
			this.set('chosenTeam', answersArray[0].answer);
		}
	}
}
